// @flow

import React, { Component } from 'react'
import './ProfileOrGroupList.css'

type Props = {
  data: Array,
  title: string
}

/**
  * Diplay for profile/group list
  * @class
  * @extends Component
*/
class ProfileOrGroupList extends Component<Props> {
  /** render function */
  render () {
    const content = this.props.data.map((pgnames, index) => {
      return (
        <span key={index} className='ProfileOrGroupDisplay'>
          {pgnames}
        </span>
      )
    })

    return (
      <div className='pgBox box'>
        <h4>{this.props.title}</h4>
        <div>{content}</div>
      </div>
    )
  }
}

export default ProfileOrGroupList
